<template>
  <dialog-base
    v-bind="$props"
    :key="renderKey"
    :header="t('user.dialogs.changePasswordDialog.headers.changeUserPassword')"
    :scrollable="false"
    :loading-message="t('user.dialogs.changePasswordDialog.messages.updating')"
    @close="close"
    @confirm="$refs.changePasswordForm.submit()">
    <template v-slot:activator="slotProps" v-if="!externalActivator">
      <slot v-if="$slots.activator" name="activator" v-bind="slotProps"></slot>
    </template>
    <template #body>
      <change-password-form @close="close" ref="changePasswordForm"></change-password-form>
    </template>
  </dialog-base>
</template>

<script>
import { t } from '@nova/core';
import dialogMixin from '@satellite/components/mixins/dialogMixin';

export default {
  mixins: [dialogMixin],
  methods: {
    t
  }
};
</script>
